require("../../app");
require("@fancyapps/fancybox");
require("slick-carousel");
require("bootstrap");
require("../../components/conversemos");

$("#galeria .slide").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#secciones a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#secciones a").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

$(document).ready(function(){
    $(".btn").click(function(){
        var piso = $(this).data("piso");
        $(".imagen").removeClass("active");
        $(piso).addClass("active");

        $(".botones .btn").removeClass("active");
        $(this).addClass("active");
    })
});
